import { inject, Injectable } from "@angular/core";
import { MCAuthoritiesEventsCountries, MCCustomFunctionsParams } from "@maslul/common-services";
import { RequestApprovalTypeDetailsStore } from "../../../store/approval-type-details-store";
import { ApprovalTypeData } from "../../../approval-type/approvals-type-data";

@Injectable({
    providedIn: 'root'
})
export class AuthoritiesEventsCountries extends MCAuthoritiesEventsCountries {

    private requestApprovalTypeDetailsStore = inject(RequestApprovalTypeDetailsStore);

    override isWithoutCountriesGroup(_customFunctionsParams: MCCustomFunctionsParams): boolean {
        const approvalTypeId = this.requestApprovalTypeDetailsStore.getSnapshot().approvalTypeId;
        return !!ApprovalTypeData.approvalTypeToExcludeCountriesGroup.find(x => x == Number(approvalTypeId));
    }
}
